import { FullScreenTakeOver, NavBar, NavBarVariant } from 'ui/takeOver';
import { BreakdownType } from './JourneyVisitorBreakdown.constant';
import { closeTakeover, getWorkflow } from 'modules/workflows/ducks';
import { useDispatch, useSelector } from 'react-redux';
import { TakeoverType } from '../takeovers.constants';
import { ChatButton } from 'ui/button/ChatButton';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { selectIsSupportChatTestFeatureFlagOn } from 'core/userContext';
import { JourneyVisitorBreakdownTable } from './JourneyVisitorBreakdownTable';
import { getTitle } from './journeyVisitorBreakdown.utils';

export const JOURNEY_VISITOR_TAKEOVER_TEST_ID = 'journey-visitor-takeover';

export type JourneyVisitorBreakdownTakeoverProps = {
  breakdownType: BreakdownType;
  nodeId?: number;
  numUserTotal: number;
};

export const JourneyVisitorBreakdownTakeover = ({
  numUserTotal,
  breakdownType,
  nodeId,
}: JourneyVisitorBreakdownTakeoverProps) => {
  const isSupportChatTestEnabled = useSelector(selectIsSupportChatTestFeatureFlagOn);
  const dispatch = useDispatch();
  const workflow = useSelector(getWorkflow);
  const onClose = () => dispatch(closeTakeover(TakeoverType.JourneyVisitorBreakdown));
  const title = getTitle(breakdownType, workflow?.id, workflow?.name || '');
  return (
    <FullScreenTakeOver
      data-testid={JOURNEY_VISITOR_TAKEOVER_TEST_ID}
      onClose={onClose}
      title={getTitle(BreakdownType.VisitorsEntered, workflow.id, workflow?.name || '')}
      NavBar={
        <NavBar
          variant={NavBarVariant.Focus}
          title={title}
          onBackClick={onClose}
          ContentRight={
            isSupportChatTestEnabled && (
              <ChatButton size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.GHOST} />
            )
          }
        />
      }
      Footer={
        <Button size={BUTTON_SIZES.LARGE} variant={BUTTON_VARIANTS.SECONDARY} onClick={onClose}>
          Close
        </Button>
      }
    >
      <JourneyVisitorBreakdownTable
        breakdownType={breakdownType}
        nodeId={nodeId}
        numUserTotal={numUserTotal}
      />
    </FullScreenTakeOver>
  );
};
